/* eslint-disable react/jsx-no-useless-fragment */
import CheckIndisponibility from '@core/application/useCases/indisponibility/checkIndisponibility';
import ShoppingCartContainer from 'components/ShoppingCart/ShoppingCartContainer';
import { RedirectProvider } from 'hooks/redirect';
import { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import DirectedOffers from 'screens/DirectedOffers';
import Home from 'screens/Home';
import Landing from 'screens/Landing';
import MyOffers from 'screens/MyOffers/index';
import MyOrderIntentions from 'screens/MyOrderIntentions';
import MyOrders from 'screens/MyOrders';
import OfferDetails from 'screens/OfferDetails/OfferDetails';
import Products from 'screens/Products';
import ServiceRequest from 'screens/ServiceRequest/ServiceRequest';
import ShoppingLkpByQRCode from 'screens/ShoppingLkpByQRCode';
import {
  getAuthorizationToken,
  getBillingDate,
  getCustomerIdSelected,
  getDeliveryDate,
  getFilterState,
  getLetterSelectedProductList,
  getOfferTypeProductList,
  getTermProductList,
  parseJwt,
  removeItensDirectedOffers,
  removeItensMyOffers,
  removeItensMyOrders,
  removeItensShoppingCart,
  setLogout,
  setPageProductList,
  setProducerUrl,
} from 'services/config';
import {
  useGetLinkSiteByUrlMutation,
  useGetLinkSiteMutation,
  useGetUserWithCustomersQuery,
} from 'services/ecommerceApi';
import { useAppDispatch } from 'store/hooks';
import { sessionSelectors } from 'store/state/selectors';
import {
  errorActions,
  offerFiltersActions,
  sessionActions,
} from 'store/state/slices';
import { verifyIsProducer } from '../services/config';
import Logout from './Logout';
import PrivateRoute from './PrivateRoute';

const UNAUTHORIZED_REQUEST = 'UNAUTHORIZED_REQUEST';

function Router() {
  const token = getAuthorizationToken();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [getLinkSite] = useGetLinkSiteMutation();
  const isAuthenticated = useSelector(sessionSelectors.getAuthenticated);
  const producerUrl = useSelector(sessionSelectors.getProducerUrl);

  const [getLinkSiteByUrl] = useGetLinkSiteByUrlMutation();

  useEffect(() => {
    if (token && token.length > 0 && token[0] !== '') {
      dispatch(sessionActions.loginSuccess());
    } else {
      dispatch(sessionActions.loginError());
    }
  }, [dispatch, token]);

  const {
    data: user,
    isSuccess,
    isError,
    isLoading,
  } = useGetUserWithCustomersQuery(undefined, {
    skip: !isAuthenticated || !token || token?.length <= 0 || token[0] === '',
  });

  useEffect(() => {
    if (isSuccess && user) {
      // if (user.customers.length <= 0) { //
      //   dispatch(errorActions.throw(UNAUTHORIZED_REQUEST));
      // };
      //
      dispatch(sessionActions.update({ user }));

      const deliveryDates = {
        deliveryDate: getDeliveryDate(),
        billingDate: getBillingDate(),
      };
      const selectedCustomer = getCustomerIdSelected();

      dispatch(sessionActions.setDates(deliveryDates));

      if (selectedCustomer) {
        dispatch(sessionActions.setSelectedCustomer(+selectedCustomer));
      }

      if (isAuthenticated) {
        const filterState = getFilterState();

        const offerTypes = getOfferTypeProductList();
        const name = getTermProductList();
        const initial = getLetterSelectedProductList() || undefined;

        if (filterState) {
          if (offerTypes?.length) {
            dispatch(
              offerFiltersActions.filter({
                ...getFilterState(),
                name,
                offerTypes,
                initial,
              }),
            );
          } else {
            dispatch(
              offerFiltersActions.filter({
                ...getFilterState(),
                name,
                initial,
              }),
            );
          }
        }
      }
    } else if (isError && !isSuccess && !isLoading) {
      navigate(producerUrl || 'veiling');
    }
  }, [isSuccess, user, isLoading]);

  useEffect(() => {
    dispatch(errorActions.clear());
    if (location.pathname.includes('/logout')) {
      setLogout();
    }
    if (!location.pathname.includes('/shopping-cart')) {
      removeItensShoppingCart();
    }
    if (!location.pathname.includes('/my-offers')) {
      removeItensMyOffers();
    }
    if (!location.pathname.includes('/directed-offers')) {
      removeItensDirectedOffers();
    }
    if (!location.pathname.includes('/my-orders')) {
      removeItensMyOrders();
    }
  }, [dispatch, location]);

  const getSiteLink = async (paramUrl: string, path: string) => {
    console.log(
      '--------------------------------------------------------------',
    );
    console.log('Entrou no Get site:');
    console.log('o param url: ', paramUrl);
    console.log('o path: ', path);

    const pathValidate = path.split('/');

    console.log('pathValidate', pathValidate);

    if (
      pathValidate.filter((pathValid) => pathValid)?.length <= 1 &&
      (!paramUrl || paramUrl === '/')
    ) {
      console.log('o param url esta vazio');
      dispatch(
        sessionActions.setProducerPage({
          producerUrl: 'veiling',
          sitesIds: [],
        }),
      );
      setProducerUrl('veiling');
      navigate('/veiling');
      return;
    }

    const paramSession = localStorage.getItem('producerUrl') ?? '';

    if (paramUrl === 'producerUndefined') {
      paramUrl = paramSession;
    }

    console.log('ParamUrl post producerUndefined', paramUrl);
    console.log('paramSession post producerUndefined', paramSession);
    console.log('producerUrl', producerUrl);

    if (!producerUrl && paramSession) {
      dispatch(
        sessionActions.setProducerPage({
          producerUrl: paramSession,
          sitesIds: [],
        }),
      );
    }

    if (
      paramUrl !== producerUrl &&
      verifyIsProducer(parseJwt(getAuthorizationToken()))
    ) {
      const resultProducerUrls: any = await getLinkSite();
      if (resultProducerUrls?.data) {
        dispatch(
          sessionActions.setProducerInformations({
            isProducerAuthenticated: true,
            urls: resultProducerUrls?.data,
          }),
        );
      } else {
        dispatch(
          sessionActions.setProducerInformations({
            isProducerAuthenticated: true,
            urls: [],
          }),
        );
      }
    }

    if (
      paramUrl &&
      paramUrl !== '/' &&
      paramUrl !== producerUrl &&
      !paramUrl.includes('veiling')
    ) {
      const result: any = await getLinkSiteByUrl(paramUrl);
      if (result?.data) {
        dispatch(
          sessionActions.setProducerPage({
            producerUrl: result?.data?.url,
            sitesIds: result?.data?.producerIds ?? [],
          }),
        );

        dispatch(
          offerFiltersActions.filter({
            siteId: result?.data?.producerIds ?? [],
          }),
        );

        setProducerUrl(result?.data?.url);
        setPageProductList(1);
        if (pathValidate.filter((pathValid) => pathValid)?.length > 1) {
          navigate(`${path.replace(paramUrl, result?.data?.url)}`);
        } else {
          navigate(`${result?.data?.url}/products`);
        }
      } else {
        dispatch(
          sessionActions.setProducerPage({
            producerUrl: 'veiling',
            sitesIds: [],
          }),
        );

        navigate('/veiling');
        setProducerUrl('veiling');
      }
    } else if (
      (!producerUrl && !paramSession) ||
      (!producerUrl.includes('veiling') && paramUrl.includes('veiling'))
    ) {
      dispatch(
        sessionActions.setProducerPage({
          producerUrl: 'veiling',
          sitesIds: [],
        }),
      );
      setProducerUrl('veiling');

      if (pathValidate.filter((pathValid) => pathValid)?.length > 1) {
        navigate(`${path}`);
      } else {
        navigate('/veiling');
      }
    }
  };

  useEffect(() => {
    let paramUrl = '';
    let path = '';

    path = location.pathname;
    console.log('path', path);
    const lastBarIndex = path.indexOf('/', 2);
    console.log('lastBarIndex', lastBarIndex);
    paramUrl = path.substring(1, lastBarIndex > 0 ? lastBarIndex : undefined);
    console.log('paramUrl', paramUrl);
    if (paramUrl !== 'oauth' && paramUrl !== 'logout') {
      getSiteLink(paramUrl, path);
    }
  }, [dispatch, location, navigate]);

  useEffect(() => {
    const checkIndisponibility = new CheckIndisponibility();
    checkIndisponibility.execute();
  }, []);

  return (
    <>
      {(producerUrl ||
        location.pathname.includes('oauth') ||
        location.pathname.includes('logout')) && (
        <RedirectProvider>
          <Routes>
            <Route path="/:producer/" element={<Home />} />
            <Route path="/oauth" element={<Landing />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/:producer/products" element={<Products />} />

            <Route path="/:producer/products/:slug" element={<Products />} />

            <Route
              path="/:producer/products/:slug/:siteId"
              element={<Products />}
            />

            <Route
              path="/:producer/my-offers"
              element={<PrivateRoute element={<MyOffers />} />}
            />
            <Route
              path="/:producer/directed-offers"
              element={<PrivateRoute element={<DirectedOffers />} />}
            />
            <Route
              path="/:producer/offer-details/:offerId/:offerType/:packingSelectedId/:packingTypeSale"
              element={<PrivateRoute element={<OfferDetails />} />}
            />
            <Route
              path="/:producer/shopping-cart"
              element={<PrivateRoute element={<ShoppingCartContainer />} />}
            />
            <Route
              path="/:producer/read-qrcode"
              element={<PrivateRoute element={<ShoppingLkpByQRCode />} />}
            />
            <Route
              path="/:producer/my-orders"
              element={<PrivateRoute element={<MyOrders />} />}
            />
            <Route
              path="/:producer/my-order-intentions"
              element={<PrivateRoute element={<MyOrderIntentions />} />}
            />
            <Route
              path="/:producer/service-request"
              element={<PrivateRoute element={<ServiceRequest />} />}
            />
          </Routes>
        </RedirectProvider>
      )}
    </>
  );
}

export default memo(Router);
